import UrlParameters from "./urlParameters";
import jwt from 'jsonwebtoken';

/**
 * notifica o sankhya on retornando o token e account_id
 * @param {*} token
 */
export function notifySankhyaOm(token) {
    let url = window.location.href;
    let parameters = UrlParameters(url);
    const tokenData = jwt.decode(token);

    if (parameters["url"] && parameters["url"].includes('mge')) {
        window.parent.postMessage({ account_id: tokenData.id, token: token }, parameters["url"]);
    }
}

export default { notifySankhyaOm }
